import { NarrowIndexable } from "@dtm-frontend/shared/utils";
import { Color, LabelStyle } from "cesium";
import { LabelProps, defaultLabelProps } from "./label-props";

export const DEFAULT_LABEL_PROPS: LabelProps = {
    ...defaultLabelProps,
    font: "18px Roboto",
    outlineWidth: 4,
    fillColor: Color.WHITE,
    outlineColor: Color.fromCssColorString("rgb(6, 22, 54)"), // $legacy-color-gray-900
    style: LabelStyle.FILL_AND_OUTLINE,
    disableDepthTestDistance: Number.POSITIVE_INFINITY,
};

export type LabelFn<T, R = string> = (value: T) => R | undefined;
export interface LabelProviders {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [providerKey: string]: LabelFn<any, any> | undefined;
}

export interface EntityLabel<T extends LabelProviders> extends LabelProps {
    id: keyof NarrowIndexable<T>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    text: any;
    entityId?: string;
}
